import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNotifications } from '../../contexts/notificationContext';
import AddressModel from '../../models/AddressModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { DataResult } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';
import AddressControl from './Controls/AddressControl';

const AddressView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<DataResult<AddressModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<AddressModel>();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

    let AddressId: number | undefined;
    let idParams: IdParams = useParams();
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        AddressId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (AddressId !== undefined) {
            DataService.getById<AddressModel>('api/v1/Addresses/', AddressId)
                .then(response => {
                    setFormData(response);
                })
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [AddressId]);

    function submit() {
        if (formData) {
            DataService
                .update<AddressModel>(`api/v1/Addresses/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    function setFieldValue(name: string, value: string) {
        if (formData) {
            name.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setFormData(formData);
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, formData);
        }
    }

    if (!isAuthorized)
        return (<Unauthorized />);

    if (!formData)
        return <h5 style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading...</h5>;

    return (
        <div className='main-content'>
            <AddressControl formData={formData} handleFieldChanged={setFieldValue} handleSubmit={submit} serverErrors={serverErrors} />
        </div>
    );
}
export default AddressView;